'use client'

import { Image } from '@vinted/web-ui'

import { ElectronicsHowSectionCardModel } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

const HowSectionCard = ({
  imageUrl,
  title,
  description,
  index,
}: ElectronicsHowSectionCardModel & { index: number }) => {
  return (
    <article className="electronics__how-card" data-testid="electronics-how-card">
      <div className="electronics__how-card-image">
        <Image src={imageUrl} scaling={Image.Scaling.Cover} loading="lazy" />
      </div>
      <div>
        <h3 className="electronics__how-card-title">
          <span className="electronics__how-card-title-number">{`${index + 1}.`}</span>
          <span className="electronics__how-card-title-text">{title}</span>
        </h3>
        <p className="electronics__how-card-description">{description}</p>
      </div>
    </article>
  )
}

export default HowSectionCard
